import React, { useState, useEffect } from 'react';
import { useTable } from 'react-table';
import './Table.css';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { ensureConfig, getConfig } from '@edx/frontend-platform';	

ensureConfig([
  'STUDIO_BASE_URL' 
], 'Table component');

const Table = () => {
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const [totalEntries, setTotalEntries] = useState(0); // To handle total entries from the API

    useEffect(() => {
        const fetchData = async () => {
             const requestBody = {
                 start: (currentPage - 1) * entriesPerPage, // Start index based on current page
                 length: entriesPerPage, // Number of entries per page
                 search: {
                     value: searchText || "", // Search query
                 }
             };

            try {
                const response = await fetch(`${getConfig().STUDIO_BASE_URL}/api/notification/notifications/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody),
                });
                const result = await response.json();
                console.log('Fetched Data:', result.notifications); // Log the fetched notifications
                setData(result.notifications); // Store the notifications data
                setTotalEntries(result.total_count); // Set total number of entries for pagination
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [currentPage, entriesPerPage, searchText]);

    // useEffect(() => {
    //     fetch('/api/notification/notifications/')
    //         .then(response => response.json())
    //         .then(data => {
    //             console.log('Fetched Data:', data); // Log the fetched data
    //             setData(data.notifications);
    //         })
    //         .catch(error => console.error('Error fetching data:', error));
    // }, []);

    const handleEntriesChange = (event) => {
        setEntriesPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1); // Reset to the first page when changing entries per page
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
        setCurrentPage(1); // Reset to the first page when performing a search
    };

    // Apply search filter to the data
    // const filteredData = data.filter(item => {
    //     const isMatch = (
    //         (item.srNo && item.srNo.toString().toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.dateTime && item.dateTime.toString().toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.type && item.type.toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.notificationTitle && item.notificationTitle.toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.details && item.details.toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.link && item.link.toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.category && item.category.toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.program && item.program.toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.course && item.course.toLowerCase().includes(searchText.toLowerCase())) ||
    //         (item.audiences && item.audiences.toLowerCase().includes(searchText.toLowerCase()))
    //     );
    //     return isMatch;
    // });
    const filteredData = data.filter(item => {
        const isMatch = (
            (item.title && item.title.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.type && item.type.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.content && item.content.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.category && item.category.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.recipients && item.recipients.toLowerCase().includes(searchText.toLowerCase()))
        );
        return isMatch;
    });
    

    console.log('Filtered Data:', filteredData); // Log the filtered data

    // Paginate the filtered data
    //const indexOfLastEntry = currentPage * entriesPerPage;
    //const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    //const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);

    const indexOfFirstEntry = (currentPage - 1) * entriesPerPage;
    const indexOfLastEntry = indexOfFirstEntry + entriesPerPage;

    //const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return null; // Handle invalid dates

  const options = {
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric',
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit',
    hour12: true, // 12-hour format with AM/PM
  };

  let formattedTimestamp = new Intl.DateTimeFormat('en-GB', options).format(date);

  // Capitalize AM/PM
  formattedTimestamp = formattedTimestamp.replace(/(\s)(am|pm)/i, (_, space, ampm) => {
    return `${space}${ampm.toUpperCase()}`;
  });

  return formattedTimestamp;
};

    const paginationWindow = 1; // Number of pages to show around the current page

    const getPageNumbers = () => {
        const pageNumbers = [];
        const startPage = Math.max(currentPage - paginationWindow, 1);
        const endPage = Math.min(currentPage + paginationWindow, totalPages);

        // Add the first page and ellipsis if needed
        if (startPage > 1) {
            pageNumbers.push(1);
            if (startPage > 2) {
                pageNumbers.push('...');
            }
        }

        // Add pages within the window
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        // Add the last page and ellipsis if needed
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageNumbers.push('...');
            }
            pageNumbers.push(totalPages);
        }

        return pageNumbers;
    };

    // const columns = React.useMemo(
    //     () => [
    //         { Header: 'Sr.No', accessor: 'srNo' },
    //         { Header: 'Date & Time', accessor: 'dateTime' },
    //         { Header: 'Type', accessor: 'type' },
    //         { Header: 'Notification Title', accessor: 'notificationTitle' },
    //         { Header: 'Details', accessor: 'details' },
    //         { Header: 'Link', accessor: 'link' },
    //         { Header: 'Category', accessor: 'category' },
    //         { Header: 'Program', accessor: 'program' },
    //         { Header: 'Course', accessor: 'course' },
    //         { Header: 'Audiences', accessor: 'audiences' }
    //     ],
    //     []
    // );


    const truncateText = (text, maxLength) => {
        if (!text) return '';
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };    


    const columns = React.useMemo(
        () => [
            { Header: 'SrNo.', accessor: 'sr_no'},
            { Header: 'Date & Time', accessor: (row) => formatTimestamp(row.timestamp) },
            { Header: 'Type', accessor: 'type' },
            { Header: 'Notification Title', accessor: 'title' },
            { Header: 'Details', accessor: 'content' },
            { 
                Header: 'Link', 
                accessor: 'web_link',
                Cell: ({ value }) => (
                    value ? (
                    <a 
                        href={value}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={value}
                        className="truncated-link"
                    >
                        {truncateText(value, 20)}
                    </a>
                    ) : '-'
                )
            },
            { Header: 'Category', accessor: 'category' },
            { Header: 'Program', accessor: 'program', Cell: ({ value }) => (value && value.length > 0 ? value[0].display_name : '-') },
            { Header: 'Course', accessor: 'course', Cell: ({ value }) => (value && value.length > 0 ? value[0].display_name : '-') },
            { Header: 'Audiences', accessor: 'recipients' }
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable(
        { columns, data: filteredData, },
    );

    return (
        <div className="table-container">
            <div className="table-heading">
                <div className='heading'>
                    <h2>Notifications</h2>
                </div>
                <div className="notifiction">
                    <Link to="notification-modal">
                        <button className='notification-button'>Notification Panel</button>
                    </Link>
                </div>
            </div>
            <div className="search-bar">
                <label>
                    Show
                    <select value={entriesPerPage} onChange={handleEntriesChange}>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                    </select>
                    entries
                </label>

                <label>
                    <input
                        type="text"
                        placeholder="Search"
                        value={searchText}
                        onChange={handleSearchChange}
                    />
                </label>
            </div>
            <div className="table-widget-container">
                <table {...getTableProps()} className="react-table">
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th key={column.id} {...column.getHeaderProps()}>{column.render('Header')}</th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row);
                            return (
                                <tr key={row.id} {...row.getRowProps()}>
                                    {row.cells.map(cell => (
                                        <td key={cell.column.id} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>


            <div className="pagination">
                <div className='pagination-text'>
                    <span>
                         {`Showing ${indexOfFirstEntry + 1} to ${Math.min(indexOfLastEntry, totalEntries)} of ${totalEntries} entries`}
                    </span>
                </div>

                <div className='pagination-number'>
                    <button className='prev'
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {getPageNumbers().map((page, index) => (
                        <button
                            key={index}
                            onClick={() => page !== '...' && handlePageChange(page)}
                            className={`number ${currentPage === page ? 'active' : ''}`}
                            disabled={page === '...'}
                        >
                            {page}
                        </button>
                    ))}
                    <button className='prev'
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Table;
